import { Component, OnInit } from '@angular/core'; 
import { FormBuilder, Validators, FormGroup } from '@angular/forms'; 
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service'; 
import { formatDate } from '@angular/common'; import { Constants } from '../../../../_utils/Constants'; 
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service'; 
import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';

 @Component({
  selector: 'app-import-preference',
  templateUrl: './import-preference.component.html',
  styleUrls: ['./import-preference.component.css']
})
export class ImportPreferenceComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private imp: APIImportPreferenceService,
    private db: $DBManagerService,
    private $modal: $ModalManagerService,
  ) { }
  // uploadNcpr: FileList;
  importForm: FormGroup;
  submitted: boolean = false;
  compRadio: boolean = false;
  preferenceOrComplaint: any;
  filecheck: boolean = false;
  fileExtensionError: boolean = false;
  fileExtensionError1: boolean = false;
  fileExtensionError2: boolean = false;
  fileExtensionMessage: any;
  fileExtension: any;
  complaintOptions: any;
  csvName:any;
  validfilecontent: any
  //uploadNcpr: string[];
  uploadNcpr: string;
  public Entity_Ref_No: any;
  public Entity_Name: any;
  ngOnInit() {
    this.importForm = this.fb.group({
      selectedOptions: ['', Validators.required],
      uploadNcpr: ['', Validators.required],
      compOptions: ['',]
    });
  }
  get f() { return this.importForm.controls; }
  onChangeSelOpt(event) {
this.filecheck = 
false;

console.log(this.filecheck)
    console.log("calling onChangeSelOpt")
    this.compRadio = event.value;
    console.log("compRadio : ", this.compRadio)
//for checking if file is there
this.filecheck = 
true;

console.log(this.filecheck)

    this.preferenceOrComplaint = event.value;
    //console.log("CHKBOXXXXXXX ",this.preferenceOrComplaint);
    if (event.value == 'complaints') {
      this.importForm.controls['compOptions'].setValidators(Validators.required);
    }
    else {
      this.importForm.controls['compOptions'].setValidators(Validators.nullValidator);
      this.importForm.controls['compOptions'].setValue("");
    }
    this.importForm.controls['compOptions'].updateValueAndValidity();
  }
  onChangeComplaintOptions(event) {
    console.log("calling onChangeComplaintOptions")
    this.complaintOptions = event.value;
  
  }
  

  
  
//removing the file
    resetFile()
    {
      console.log(this.importForm.controls['uploadNcpr'].value);
      this.importForm.controls['uploadNcpr'].reset();
	 
      this.uploadNcpr=null;
      console.log(this.importForm.controls['uploadNcprz'].value);
		
    }
    //my commits
     
getHeaderArray(csvRecordsArr: any) {
   let headers = csvRecordsArr[0].split(",");
   let headerArray = [];
     
   for (let j = 0; j < headers.length; j++) {
               headerArray.push(headers[j]);
   }      
 if( (headerArray[0]== "ServiceAreaCode") && (headerArray[1]== "PhoneNumbers") && (headerArray[2]== "Preferences") && (headerArray[3]== "Opstype") && 
(headerArray[4]== "PhoneType"))
      {
          this.validfilecontent = true
        console.log("Valid CSV Contents")
      }
	   else if ((headerArray[0]== "S.No.") && (headerArray[1]== "Header")&& (headerArray[2]== "RTM/TMSE")&& (headerArray[3]== "Nature")&& (headerArray[4]== "Purpose")){
        this.validfilecontent = true
        console.log("Valid CSV Contents")
      }
      else
      {
          this.validfilecontent = false
         console.log("Status update",this.validfilecontent)
      }    
} 
 getHeaderArrayComp(csvRecordsArr: any) {
   let headers = csvRecordsArr[2].split(",");
   let headerArray = [];
     
   for (let j = 0; j < headers.length; j++) {
               headerArray.push(headers[j]);
   }      
 console.log("The Header Array", headerArray);

if((headerArray[0]== "S.No."))
 {
          this.validfilecontent = true
        console.log("Valid CSV Contents")
      }
      else
      {
          this.validfilecontent = false
        alert("Invalid File Contents")
         console.log("Status update",this.validfilecontent)
      }    
} 
	isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
	}
   //end of my commits
  onChangeFileUpload(event) {
    //my commits
           console.log(this.complaintOptions)
	if( this.complaintOptions == "complaintByJIO" || this.complaintOptions == "responseByOthers" ){
		
		 //my commits
     var files = event.srcElement.files;
          var input = event.target;
          var reader = new FileReader();
          reader.readAsText(input.files[0]);
          reader.onload = (data) => {
          let csvData = reader.result;
          let csvRecordsArray = csvData.split(/\r\n|\n/);
          let headersRow = this.getHeaderArrayComp(csvRecordsArray);
      }
    //end of commits
	   
	   }
	   else {
     var files = event.srcElement.files;
          var input = event.target;
          var reader = new FileReader();
          reader.readAsText(input.files[0]);
          reader.onload = (data) => {
          let csvData = reader.result;
          let csvRecordsArray = csvData.split(/\r\n|\n/);
          let headersRow = this.getHeaderArray(csvRecordsArray);
      }
    //end of commits
    //this.uploadNcpr = event.target.files;
    this.uploadNcpr = event.target.files[0];
    console.log("this.uploadNcpr :", this.uploadNcpr);
	
  }
  console.log("File name ------------  ",this.uploadNcpr["name"]);
  
  var fileName = event.target.files[0];
  this.csvName=fileName["name"];
  
    console.log("the size is ", fileName.size)
    if (fileName.size > 4242880) {
      console.log("The size is more ")
      this.fileExtensionError1=true;
    }
    else{
      this.fileExtensionError1=false;
    }
	if (fileName.size <= 0) {
      console.log("The size is less ")
      this.fileExtensionError2=true;
    }
    else{
      this.fileExtensionError2=false;
    }

  
  var allowedExtensions = [ "csv"];
  
   this.fileExtension = this.csvName.split('.').pop();

    if (this.isInArray(allowedExtensions, this.fileExtension)) { 
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
    } else {
      this.fileExtensionMessage = "Only csv allowed!!"
      this.fileExtensionError = true;
    }

  
  }

  
  onSubmit() {
    this.Entity_Ref_No = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
    this.Entity_Name = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME);
   
    this.submitted = true;
    const importForm: FormData = new FormData();
    let now = new Date();
    const uploadDate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
    const file1: any = document.getElementById('uploadNcpr');
    console.log("file changed:", file1.files[0])
    console.log("my comments:", file1)
    /*console.log("file :", file1.files[0]);*/
    importForm.append('file1', file1.files[0]);
    importForm.append('uploadDate', uploadDate);
    importForm.append('Entity_Ref_No', this.Entity_Ref_No);
    importForm.append('Entity_Name', this.Entity_Name);
    importForm.append('count', "1");

console.log("=======count====", "1");

    if (this.importForm.invalid) {
      console.log("Invalid form: ", this.importForm);
      return;
    }
    else if((this.validfilecontent == true)){
      if (this.preferenceOrComplaint === "complaints" ) {
        importForm.append('complaintType', this.complaintOptions);
        this.imp.importComplaints(importForm)
          .subscribe(r => {
            console.log("success : ", r);
            // if(r.status == "success"){
            this.$modal.successModal({
              title: 'Import Complaints',
              msg: 'Complaints File Uploaded Successfully!'
            });
            // }
          })
      }
	   else if(this.preferenceOrComplaint === "header" ) {
        importForm.append('complaintType', this.complaintOptions);
        this.imp.importComplaints(importForm)
          .subscribe(r => {
            console.log("success : ", r);
            // if(r.status == "success"){
            this.$modal.successModal({
              title: 'Import Complaints',
              msg: 'Complaints File Uploaded Successfully!'
            });
            // }
          })
      }
	     else if(this.preferenceOrComplaint === "header" ){
        console.log("header importForm in header",this.importForm);
        //importForm.append('headerType', this.headerOptions);
        console.log("header importForm after : ",this.importForm.asyncValidator);
         this.imp.importHeader(importForm)
          .subscribe(r => {
            console.log("response : ", r);
            if(r.status == "success"){
            this.$modal.successModal({
              title: 'Import Header',
              msg: 'Header File Uploaded Successfully!'
            });
            }
            else if(r.status == "fail"){
              this.$modal.errorModal({
                title: 'Import Header',
                msg: 'Invalid File Format!'
              });
            }
          })
      }   
      else {
        console.log("importForm",this.importForm);
		
        this.imp.importPref(importForm)
          .subscribe(r => {
            console.log("response : ", r);
	     console.log("r.status :",r.status);
            if(r.status == "success"){
            this.$modal.successModal({  
              title: 'Import Preference', 
              msg: 'Request ID: '+r.preferenceSummary.BatchId
			  });
			  if(r.status == "success"){
			   this.$modal.successModal({  
                title: 'Import Preference', 
                msg: 'Preference File Uploaded Successfully!'
     			  });
			  }	
            }
            else if(r.status == "fail"){
              this.$modal.errorModal({
                title: 'Import Preference',
                msg: 'Invalid File Format!'
              });
            }
 		else if(r.status == "failed"){
              this.$modal.errorModal({
                title: 'Import Preference',
                msg: 'Preference upload failed due to invalid data!'
              });
            }
          })
      }
    }
   else{
     alert("upload a valid CSV File");
    }
  }
}
